/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Sign In",
  size: 20
}

const SvgSignIn = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M7 2h10v15H7v-1h9V3H7z" />
    <path d="M9.1 13.4l-.6-.6 2.78-2.8H4V9h7.28L8.5 6.2l.6-.58L13 9.5z" />
  </Svg>
)

SvgSignIn.defaultProps = defaultProps
export default SvgSignIn
